import apiSystem from './apiSystem'
import newApiSystem from './newApiSystem'


const SystemServices = {
  async createPlace(place) {
    const res = await apiSystem.post('/place', place)
    return res.data
  },
  async fetchShipperPlaces() {
    const res = await apiSystem.get('/place/search')
    return res.data
  },
  async fetchAvailableCertificates() {
    const res = await apiSystem.get('/certification')
    return res.data
  },
  async fetchAvailableProperty() {
    const res = await apiSystem.get('/property')
    return res.data
  },
  async fetchIncidentCategories() {
    const res = await apiSystem.get('/occurrencetype')
    return res.data
  },
  async fetchOccurrenceTypesByShipperId(shipperId) {
    const res = await apiSystem.get(`/shipperoccurrencetype?shipperId=${shipperId}`)
    return res
  },
  async chatUserData(payload) {
    const res = await newApiSystem.post('/chat/userData', payload)
    return res
  },
}

export default SystemServices
